import * as UH from './../util/UrlHttp'
import axios from 'axios'

export const GetMyBets = async (id:string|null) => {

    return await axios.get(`${UH.BASE_URL}bets/${id}`, UH.HEADER_HTTP_TOKEN)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return error;
                });
}

export const UpdateMyBets = async (data:any) => {

    return await axios.post(`${UH.BASE_URL}bets/`, data, UH.HEADER_HTTP_TOKEN)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return error;
                });
}



